import { motion } from "framer-motion";

const variants = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0 },
};

export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
    const MotionTag = motion[as] || motion.div;
    return (
        <MotionTag
            className={className}
            variants={variants}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
        >
            {children}
        </MotionTag>
    );
};
